import type { ComponentStyleConfig } from '@chakra-ui/theme';

const DropdownOption: ComponentStyleConfig = {
  baseStyle: {
    fontSize: 'lg',
    lineHeight: '24px',
    fontWeight: 400,
    h: '48px',
    alignItems: 'center',
    m: '1px 0',
    p: '0 16px 0 16px',
    borderRadius: '8px',
    display: 'grid',
    gridColumnGap: '1.2rem',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease-in-out',
    _focus: {
      outlineOffset: '-0.4rem',
    },
    input: {
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      overflow: 'hidden',
      position: 'absolute !important',
      width: 1,
    },
    label: {
      m: 0,
      lineHeight: '48px',
    },
  },
};

export default DropdownOption;
